module.exports = __webpack_public_path__ + "static/media/bfile-offroad.42ab068e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-offroad.svg
// module id = 558
// module chunks = 0